import { render, staticRenderFns } from "./ScannedDossieSelected.vue?vue&type=template&id=1af30009&"
import script from "./ScannedDossieSelected.vue?vue&type=script&lang=js&"
export * from "./ScannedDossieSelected.vue?vue&type=script&lang=js&"
import style0 from "./ScannedDossieSelected.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports